import { DataGridTemplate } from "../../../../shared/data-grid/data-grid.template";
import { ComponentDetail } from "./component-detail.template";
import { FormGroup, FormBuilder } from "@angular/forms";
import { FilterableService } from "../../../mesc/filterable-service";
import { Injector } from "@angular/core";

export class ComponentCategories extends DataGridTemplate {
    editForm: FormGroup;
    componentCategories: FilterableService = new FilterableService();
    private readonly formBuilder: FormBuilder;

    constructor(private readonly injector: Injector) {
        super();
        this.detailTemplate = new ComponentDetail(injector);
        this.pageable = false;
        this.controls.edit = false;
        this.controls.delete = false;
        this.controls.excel = false;
        this.controls.add = false;
        this.saveUserSettings = false;
        this.isNotificationsEnabled = false;
        this.gridState.take = 999;
        this.formBuilder = injector.get(FormBuilder);
        this.editForm = this.formBuilder.group({
            ComponentCategories: []
        })
        this.componentCategories
            .subscribe(x => {
                this.refresh();
                this.detailTemplate.setComponents(x);
            });
    }

    setToolingComponentList = (data: any) => {
        if (data) this.componentCategories.next(data)
        this.editForm.get('ComponentCategories').setValue(data);
    }

    read(opts: any): Promise<any> {
        return Promise.resolve(this.componentCategories.value);
    }

    create(parentEditDataItem: any): void { }

    edit(dataItem: any): void { }

    save(dataItem: any, isNew: boolean): Promise<any> { return null }

    delete(dataItem: any): Promise<any> { return null }

    reset() {
        this.componentCategories.next([]);
    }

    columns: any[] = [
        {
            field: 'componentCategoryView.Name',
            title: 'Category',
            filterable: true,
            detail: {
                field: 'componentCategoryView',
                textField: 'Name'
            },
        },
        {
            field: 'componentCategoryView.PTE',
            title: 'PTE',
            width: 90
        }
    ];
}
